import React, { useEffect, useState, useCallback } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { useHistory, useLocation } from 'react-router-dom';
import { FaPlus, FaSave, FaTrash, FaChevronDown, FaChevronRight, FaCopy } from 'react-icons/fa';
import api from '../../services/api';
import { toast } from 'react-toastify';
import ReactSelect from '../../components/ReactSelect';
import { FinField, FinInput } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';
import { AgenciaOrcamentoPolicy } from '../Orcamento/agenciaOrcamentoPolicy';
import { ListaOrdenavel, GrupoOrdenavel, LinhaOrdenavel, AlcaArrastar } from '../Orcamento/OrdenacaoOrcamento';
import { moverRespeitandoFixos, remapearExpandidos, idOrdenavel } from '../Orcamento/ordemOrcamentoPolicy';
import { clonarSubitemModelo, podeClonarGrupoModelo, podeClonarSubitemModelo } from './clonarLinhaModeloPolicy';
import AlertaDadosInternacionais from '../Orcamento/AlertaDadosInternacionais';
import { MSG_CLONAR_GRUPO_UNICO, contarGrupos, grupoJaIncluido, juntarGruposRepetidos, listarGruposRepetidos, rotuloOpcaoGrupo } from '../Orcamento/grupoUnicoOrcamentoPolicy';
import { rand18 } from '../../util/util';


export default function CadastroOrcamentoModelo({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const history = useHistory();
    const location = useLocation();
    const [dados, setDados] = useState({ nome: '', itens: [] });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const [expandedRows, setExpandedRows] = useState([]);
    const [carregandoOrcamento, setCarregandoOrcamento] = useState(false);
    // D-0134: quantas vezes cada grupo está gravado no modelo; a repetição que já existe não trava.
    const [gruposGravados, setGruposGravados] = useState({});
    const gruposRepetidos = listarGruposRepetidos(dados.itens, gruposGravados, 'modelo');

    const buscar = useCallback(() => {
        setIsLoading(true);
        if (!id) {
            setIsLoading(false);
            return;
        }
        api({ method: 'get', action: `/orcamentoModelo/${id}`, token })
            .then(resp => {
                const m = resp.data.data;
                const toSelectProduto = (p) => {
                    if (!p) return null;
                    if (typeof p === 'object') {
                        return { id: p.id, nome: p.nome };
                    }
                    return { id: p, nome: String(p) };
                };
                const itens = (m.itens || []).map(i => ({
                    ...i,
                    produto: toSelectProduto(i.produto),
                    subitem: (i.sub_item || []).map(s => ({
                        ...s,
                        produto: toSelectProduto(s.produto),
                    }))
                }));
                setGruposGravados(contarGrupos(itens));
                setDados({ id: m.id, nome: m.nome, itens });
            })
            .catch(() => toast.error('Erro ao carregar modelo'))
            .finally(() => { setIsLoading(false); });
    }, [id, token]);

    const carregarDadosDoOrcamento = useCallback(() => {
        setIsLoading(false);

        const urlParams = new URLSearchParams(location.search);
        const orcamentoId = urlParams.get('orcamentoId');

        if (orcamentoId) {
            setCarregandoOrcamento(true);

            // Busca os dados do orçamento
            api({ method: 'get', action: `/orcamento/${orcamentoId}`, token })
                .then(resp => {
                    const orcamento = resp.data.data;
                    const toSelectProduto = (p) => {
                        if (!p) return null;
                        if (typeof p === 'object') {
                            return { id: p.id, nome: p.nome };
                        }
                        return { id: p, nome: String(p) };
                    };

                    // Converte os itens do orçamento para o formato do modelo
                    // D-0134: modelo novo nasce sem repetição; os itens dos grupos repetidos ficam em um só grupo.
                    const { grupos: itens, juntados } = juntarGruposRepetidos((orcamento.orcamentoitem || []).map(item => ({
                        produto: toSelectProduto(item.produto),
                        chavegrupo: rand18(),
                        subitem: (item.subitem || []).map(sub => ({
                            produto: toSelectProduto(sub.produto),
                            chaveunica: rand18(),
                        }))
                    })));
                    if (juntados.length > 0) {
                        toast.warning(`O orçamento repete ${juntados.join(', ')}: no modelo, os itens ficam em um só grupo.`);
                    }

                    setDados(prev => ({ ...prev, itens }));

                    // Expande todas as linhas que têm subitens
                    const rowsToExpand = itens.map((_, index) => index);
                    setExpandedRows(rowsToExpand);
                })
                .catch(() => toast.error('Erro ao carregar dados do orçamento'))
                .finally(() => setCarregandoOrcamento(false));
        }
    }, [location.search, token]);

    const salvar = () => {
        if (!dados.nome || dados.nome.trim() === '') {
            toast.error('É necessário informar o nome do modelo');
            const el = document.getElementById('nome');
            if (el) el.focus();
            return;
        }

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        const payload = {
            nome: dados.nome,
            itens: (dados.itens || []).map((g, idx) => ({
                ordem: idx,
                produto: g.produto,
                subitem: (g.subitem || []).map((s, sIdx) => ({ ordem: sIdx, produto: s.produto }))
            }))
        };
        if (id) {
            api({ method: 'put', action: `/orcamentoModelo/${id}`, token, data: payload })
                .then((response) => { toast.success(response.data?.msg || 'Modelo atualizado'); history.push('/orcamentoModelo'); })
                .catch((err) => toast.error('Erro ao salvar: ' + (err.response?.data?.error ?? err.message ?? '')))
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {
            api({ method: 'post', action: '/orcamentoModelo', token, data: payload })
                .then((response) => { toast.success(response.data?.msg || 'Modelo criado'); history.push('/orcamentoModelo'); })
                .catch((err) => toast.error('Erro ao salvar: ' + (err.response?.data?.error ?? err.message ?? '')))
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    // Arrastar para mudar a posição e Clonar (Rafael, 15/10) — o mesmo do orçamento (07/10).
    // A posição no array vira `ordem` ao salvar (a API já grava e lê em ordem). O item só se move
    // dentro do próprio grupo. Não há linha de posição fixa no modelo.
    const moverGrupo = (de, para) => {
        const nova = moverRespeitandoFixos(dados.itens || [], de, para);
        if (!nova) return;
        setExpandedRows((atual) => remapearExpandidos(atual, de, para));
        setDados({ ...dados, itens: nova });
    };

    const moverSubitem = (indexSuperior, de, para) => {
        const grupo = (dados.itens || [])[indexSuperior];
        if (!grupo) return;
        const nova = moverRespeitandoFixos(grupo.subitem || [], de, para);
        if (!nova) return;
        setDados({ ...dados, itens: dados.itens.map((g, i) => (i === indexSuperior ? { ...g, subitem: nova } : g)) });
    };

    const clonarSubitemNaPosicao = (indexSuperior, indexInferior) => {
        const grupo = (dados.itens || [])[indexSuperior];
        const original = grupo && (grupo.subitem || [])[indexInferior];
        if (!podeClonarSubitemModelo(grupo, original)) return;
        const subitem = [...grupo.subitem];
        subitem.splice(indexInferior + 1, 0, clonarSubitemModelo(original, rand18));
        setDados({ ...dados, itens: dados.itens.map((g, i) => (i === indexSuperior ? { ...g, subitem } : g)) });
        toast.success('Subitem clonado logo abaixo do original. Clique em Salvar Modelo para gravar.');
    };

    useEffect(() => {
        if (id) {
            buscar();
        } else {
            carregarDadosDoOrcamento();
        }
    }, [buscar, carregarDadosDoOrcamento, id]);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h3 className="fin-pp__title">{id ? 'Alterar' : 'Novo'} Modelo de Orçamento</h3>
                        <p className="fin-pp__subtitle">Defina os itens (grupos) e subitens que compõem o modelo.</p>
                    </div>
                </div>

                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 18, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Nome do Modelo" required>
                                <FinInput id="nome" placeholder="Nome do Modelo" style={{ paddingLeft: 14 }}
                                    value={dados.nome}
                                    onChange={e => setDados({ ...dados, nome: e.target.value })}
                                />
                            </FinField>
                        </div>
                    </div>

                    {carregandoOrcamento && (
                        <div className="fin-pp__card" style={{ padding: 18, marginBottom: 16, textAlign: 'center', color: 'var(--fin-mt)' }}>
                            Carregando dados do orçamento...
                        </div>
                    )}

                    <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 16 }}>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl" style={{ minWidth: 520 }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 170 }}>Ações</th>
                                        <th>Item (Produto)</th>
                                    </tr>
                                </thead>
                                {(dados.itens || []).length === 0 ? (
                                    <tbody>
                                        <tr><td colSpan={2} className="fin-pp__empty">Nenhum item adicionado</td></tr>
                                    </tbody>
                                ) : (
                                <ListaOrdenavel ids={(dados.itens || []).map((g, i) => idOrdenavel('g', g, i))} onMover={moverGrupo}>
                                    {(dados.itens || []).map((item, indexSuperior) => (
                                        <GrupoOrdenavel key={idOrdenavel('g', item, indexSuperior)} id={idOrdenavel('g', item, indexSuperior)}>
                                            {(alcaGrupo) => (<>
                                            <tr style={{ background: 'var(--fin-sf2)' }}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <button
                                                            type="button"
                                                            className="fin-pp__rowbtn"
                                                            title="Expandir / Recolher"
                                                            onClick={() => {
                                                                const arr = Array.isArray(expandedRows) ? [...expandedRows] : [];
                                                                const i = arr.indexOf(indexSuperior);
                                                                if (i > -1) arr.splice(i, 1); else arr.push(indexSuperior);
                                                                setExpandedRows(arr);
                                                            }}
                                                        >
                                                            {(Array.isArray(expandedRows) && expandedRows.includes(indexSuperior)) ? <FaChevronDown size={13} /> : <FaChevronRight size={13} />}
                                                        </button>
                                                        <AlcaArrastar alca={alcaGrupo} titulo="Arraste para mudar a posição do grupo" />
                                                        {podeClonarGrupoModelo(item) && (
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled title={MSG_CLONAR_GRUPO_UNICO} data-clonar-grupo>
                                                                <FaCopy size={13} />
                                                            </button>
                                                        )}
                                                        <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" title="Remover item" onClick={() => {
                                                            dados.itens.splice(indexSuperior, 1);
                                                            setDados({ ...dados });
                                                        }}>
                                                            <FaTrash size={13} />
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <ReactSelect
                                                        placeholder={'Item (Produto)'}
                                                        value={item.produto ? { value: item.produto.id, label: item.produto.nome } : null}
                                                        isOptionDisabled={(opcao) => grupoJaIncluido(opcao.value, dados.itens, indexSuperior)}
                                                        formatOptionLabel={(opcao, { context }) => rotuloOpcaoGrupo(opcao, context, dados.itens, indexSuperior)}
                                                        onChange={(e) => {
                                                            // Trava do grupo (06/10): trocar o grupo limpa os subitens do grupo anterior.
                                                            const anterior = dados.itens[indexSuperior].produto?.id;
                                                            dados.itens[indexSuperior].produto = { id: e.value, nome: e.label };
                                                            if (String(anterior ?? '') !== String(e.value ?? '')) dados.itens[indexSuperior].subitem = [];
                                                            setDados({ ...dados });
                                                        }}
                                                        defaultOptions
                                                        loadOptions={(input) => api({ method: 'get', action: '/produto', token, params: { situacaoRegistro: 'ativo', nome: input, modulo: 'servicoOrcamento', superiorIsNull: true } })
                                                            .then(r => r.data.data.map(reg => ({ value: reg.id, label: `${reg.codigo ? reg.codigo + ' - ' : ''}${reg.nome}` })))
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            {(Array.isArray(expandedRows) && expandedRows.includes(indexSuperior)) && (
                                            <ListaOrdenavel ids={(item.subitem || []).map((sub, i) => idOrdenavel('s', sub, i))} onMover={(de, para) => moverSubitem(indexSuperior, de, para)}>
                                            {(item.subitem || []).map((sub, indexInferior) => (
                                                <LinhaOrdenavel key={idOrdenavel('s', sub, indexInferior)} id={idOrdenavel('s', sub, indexInferior)}>
                                                    {(alcaItem) => (<>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-1" style={{ paddingLeft: 12 }}>
                                                            <AlcaArrastar alca={alcaItem} size={11} titulo="Arraste para mudar a posição do subitem" />
                                                            {podeClonarSubitemModelo(item, sub) && (
                                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" title="Clonar subitem logo abaixo"
                                                                    data-clonar-item onClick={() => clonarSubitemNaPosicao(indexSuperior, indexInferior)}>
                                                                    <FaCopy size={11} />
                                                                </button>
                                                            )}
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm" title="Remover subitem" onClick={() => {
                                                                dados.itens[indexSuperior].subitem.splice(indexInferior, 1);
                                                                setDados({ ...dados });
                                                            }}>
                                                                <FaTrash size={12} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td style={{ paddingLeft: 28 }}>
                                                        <ReactSelect
                                                            placeholder={'Subitem (Produto)'}
                                                            value={sub.produto ? { value: sub.produto.id, label: sub.produto.nome } : null}
                                                            onChange={(e) => {
                                                                dados.itens[indexSuperior].subitem[indexInferior].produto = { id: e.value, nome: e.label };
                                                                setDados({ ...dados });
                                                            }}
                                                            isDisabled={!item.produto?.id}
                                                            defaultOptions
                                                            // Trava do grupo (06/10): só itens do grupo no catálogo (sem grupo, nenhum); no
                                                            // 130 - FEE só Fee Agência e Imposto, como no orçamento (filtrarOpcoesCatalogo).
                                                            loadOptions={(input) => (!item.produto?.id ? Promise.resolve([]) : api({ method: 'get', action: '/produto', token, params: { nome: input, situacaoRegistro: 'ativo', modulo: 'servicoOrcamento', superior: item.produto.id } })
                                                                .then(r => AgenciaOrcamentoPolicy.filtrarOpcoesCatalogo(item, r.data.data || [])
                                                                    .map(reg => ({ value: reg.id, label: `${reg.codigo ? reg.codigo + ' - ' : ''}${reg.nome}` }))))
                                                            }
                                                        />
                                                    </td>
                                                    </>)}
                                                </LinhaOrdenavel>
                                            ))}
                                            </ListaOrdenavel>
                                            )}
                                            {(Array.isArray(expandedRows) && expandedRows.includes(indexSuperior)) && (
                                                <tr>
                                                    <td colSpan={2} style={{ paddingLeft: 28 }}>
                                                        <button type="button" className="fin-pp__btn fin-pp__btn--ok fin-pp__btn--sm" onClick={() => {
                                                            if (!item.subitem) item.subitem = [];
                                                            item.subitem.push({ produto: null, chaveunica: rand18() });
                                                            setDados({ ...dados });
                                                        }}>
                                                            <FaPlus size={13} className="me-1" /> Adicionar Subitem
                                                        </button>
                                                    </td>
                                                </tr>
                                            )}
                                            </>)}
                                        </GrupoOrdenavel>
                                    ))}
                                </ListaOrdenavel>
                                )}
                            </table>
                        </div>
                    </div>

                    <div style={{ marginBottom: 16 }}>
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={() => {
                            dados.itens.push({ produto: null, chavegrupo: rand18(), subitem: [] });
                            setDados({ ...dados });
                        }}>
                            <FaPlus size={14} className="me-1" /> Adicionar Item (Grupo)
                        </button>
                    </div>

                    {gruposRepetidos.bloqueiam.length > 0 && (
                        <AlertaDadosInternacionais erros={gruposRepetidos.bloqueiam} titulo="Grupo repetido, corrija para salvar:" />
                    )}
                    {gruposRepetidos.avisos.length > 0 && (
                        <AlertaDadosInternacionais erros={gruposRepetidos.avisos} titulo="Grupo repetido (não trava o Salvar):" />
                    )}

                    <div className="fixoRodape" style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px 0' }}>
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting || gruposRepetidos.bloqueiam.length > 0} onClick={salvar}>
                            <FaSave size={14} className="me-1" /> {isSubmitting ? 'Salvando...' : 'Salvar Modelo'}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}


